/**
 * Every user-facing sentence of the sync review (Take Over v2).
 *
 * The sync review lists what the External EMR changed on a chart after the
 * chart moved to Roger, since someone last closed the review. Written in the
 * chart register: one claim a sentence, no asides.
 */

/** The control beside the import report, and the dialog's title. */
export const SYNC_REVIEW_LABEL = 'Sync review';

/** The control while changes wait: the count rides on the button. */
export function syncReviewButtonLabel(newCount: number): string {
  if (newCount <= 0) return SYNC_REVIEW_LABEL;
  return `${SYNC_REVIEW_LABEL} · ${newCount} new`;
}

export const SYNC_REVIEW_DESCRIPTION =
  'What the External EMR changed on this chart since this review was last closed.';

export function lastClosedLine(
  formattedDate: string,
  name: string | null | undefined
): string {
  return name
    ? `Last closed ${formattedDate} by ${name}.`
    : `Last closed ${formattedDate}.`;
}

export const SYNC_REVIEW_EMPTY_COPY =
  'Nothing new from the External EMR since this review was last closed.';

export const SYNC_REVIEW_CLOSE_ERROR_COPY =
  'Unable to clear the sync review. It stays new until it is closed again.';

/** Above the list when it holds tasks dated from the day Roger charts from. */
export const SYNC_REVIEW_ACTION_COPY =
  'Tasks marked Action are dated on or after the day Roger charts this chart. Chart that work in Roger.';

export const SYNC_REVIEW_ACTION_LABEL = 'Action';

/** Group headings, in the order the dialog shows them. */
export const SYNC_REVIEW_GROUP_TITLES: Record<string, string> = {
  new_task: 'New tasks',
  status: 'Status changed',
  notes: 'Notes changed',
  rescheduled: 'Rescheduled',
  reassigned: 'Reassigned',
  gone: 'No longer in the External EMR',
  restored: 'Back in the External EMR',
};

/** A change kind this screen does not know yet still shows, under this. */
export const SYNC_REVIEW_OTHER_GROUP_TITLE = 'Other changes';

export const SYNC_REVIEW_FAMILIES_TITLE = 'Other records added';

/**
 * What the nightly sync asks a person to do. Nightly runs never make the
 * Import report urgent, so their Action findings show here.
 */
export const SYNC_REVIEW_FINDINGS_TITLE = 'Action needed';

export function familyAddedLine(label: string, added: number): string {
  return `${label}: ${added} added`;
}

/**
 * The Patient Manager card's line while sync changes wait.
 *
 * The count is the header control's own number: the backend folds the same
 * open runs for both, so the card and the chart agree.
 */
export function patientCardSyncLine(newCount: number): string {
  return `${SYNC_REVIEW_LABEL}: ${newCount} new`;
}
